<div class="flex-auto p-6 sm:p-10">
    <div class="max-w-2xl prose prose-sm">
        <h1>{{ content.title }}</h1>

        <p>{{ content.intro }}</p>
        <p>{{ content.intro2 }}</p>
        <p>{{ content.intro3 }}</p>

        <h2>{{ content.consent?.title }}</h2>
        <p>{{ content.consent?.text }}</p>

        <h2>{{ content.informationWeCollect?.title }}</h2>
        <p>{{ content.informationWeCollect?.intro }}</p>
        <p>{{ content.informationWeCollect?.contact }}</p>
        <p>{{ content.informationWeCollect?.account }}</p>

        <h2>{{ content.howWeUseYourInformation?.title }}</h2>
        <p>{{ content.howWeUseYourInformation?.intro }}</p>
        <ul>
            <li *ngFor="let item of content.howWeUseYourInformation?.items">{{ item }}</li>
        </ul>

        <h2>{{ content.logFiles?.title }}</h2>
        <p>{{ content.logFiles?.text }}</p>

        <h2>{{ content.cookiesAndWebBeacons?.title }}</h2>
        <p>{{ content.cookiesAndWebBeacons?.text }}</p>

        <h2>{{ content.advertisingPartnersPrivacyPolicies?.title }}</h2>
        <p>{{ content.advertisingPartnersPrivacyPolicies?.intro }}</p>
        <p>{{ content.advertisingPartnersPrivacyPolicies?.text1 }}</p>
        <p>{{ content.advertisingPartnersPrivacyPolicies?.text2 }}</p>

        <h2>{{ content.thirdPartyPrivacyPolicies?.title }}</h2>
        <p>{{ content.thirdPartyPrivacyPolicies?.text1 }}</p>
        <p>{{ content.thirdPartyPrivacyPolicies?.text2 }}</p>

        <h2>{{ content.ccpaPrivacyRights?.title }}</h2>
        <p>{{ content.ccpaPrivacyRights?.intro }}</p>
        <p>{{ content.ccpaPrivacyRights?.right1 }}</p>
        <p>{{ content.ccpaPrivacyRights?.right2 }}</p>
        <p>{{ content.ccpaPrivacyRights?.right3 }}</p>
        <p>{{ content.ccpaPrivacyRights?.text }}</p>

        <h2>{{ content.gdprDataProtectionRights?.title }}</h2>
        <p>{{ content.gdprDataProtectionRights?.intro }}</p>
        <p>{{ content.gdprDataProtectionRights?.right1 }}</p>
        <p>{{ content.gdprDataProtectionRights?.right2 }}</p>
        <p>{{ content.gdprDataProtectionRights?.right3 }}</p>
        <p>{{ content.gdprDataProtectionRights?.right4 }}</p>
        <p>{{ content.gdprDataProtectionRights?.right5 }}</p>
        <p>{{ content.gdprDataProtectionRights?.right6 }}</p>
        <p>{{ content.gdprDataProtectionRights?.text }}</p>

        <h2>{{ content.howCanYourDataBeDeleted?.title }}</h2>
        <p>{{ content.howCanYourDataBeDeleted?.text }}</p>

        <h2>{{ content.childrensInformation?.title }}</h2>
        <p>{{ content.childrensInformation?.intro }}</p>
        <p>{{ content.childrensInformation?.text }}</p>
    </div>
</div>
